// extracted by mini-css-extract-plugin
module.exports = {"host":"distributor-new-button_host_3cAXP"};